import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AppUserService } from '../services/app-user.service';
import { finalize } from 'rxjs/operators';
import { StationMissingData, Ano, Mes } from '../models/missing-data-station';


/**
 * Exibe a contagem dos registros faltantes na hierarquia de estação -> ano -> mês.
 */
@Component({
  selector: 'app-missing-data',
  templateUrl: './missing-data.component.html',
  styleUrls: ['./missing-data.component.css']
})
export class MissingDataComponent implements OnInit {

  constructor(private appUserService: AppUserService) { }

  /** Lista de estações com os dados faltantes por ano e mês. */
  stations:StationMissingData[];

  /** Ano da estação selecionado pelo usuário. */
  selectedStationYear:{nome:string,ano:Ano};

  /** Lista dos nomes dos meses */
  mesString=['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

  /** Indica se os registros dos dados faltantes estão sendo baixados. */
  downloadingData:Boolean = false;

  /**
   * Na inicialização, busca os registros dos dados faltantes.
   */
  ngOnInit(): void {
    this.downloadingData=true;
    this.selectedStationYear=undefined;
    this.appUserService
    .getMissingDataPerStation().subscribe(result=>{this.stations=result;this.downloadingData=false});
  }

  /**
   * Alterna a seleção de um ano de uma estação específica.
   * @param nome nome da estação selecionada
   * @param year ano dos dados faltantes da estação
   */
  takeYear(nome:string,year:Ano){
    if (this.selectedStationYear != undefined) this.selectedStationYear = undefined;
    else this.selectedStationYear = {nome:nome,ano:year};
  }

}
